import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getPromotion({ payload: { signal, id } }) {
  try {
    const { data } = yield call(fetch, { api: api.promotions.get, id, signal });

    yield put(actions.getPromotionDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getPromotionFailed,
      endpoint: api.promotions.get.url
    });
  }
}

function* updatePromotion({ payload: { id, values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.promotions.update, id, data: values });

    onSuccess && onSuccess();
    yield put(actions.updatePromotionDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.updatePromotionFailed,
      handledErrors,
      endpoint: api.promotions.update.url
    });
  }
}

export const getPromotionSaga = takeEvery(types.GET_PROMOTION_REQUEST, getPromotion);
export const updatePromotionSaga = takeEvery(types.UPDATE_PROMOTION_REQUEST, updatePromotion);